var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('b',{},[_vm._v(_vm._s(_vm.formattedElapsedTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }